import React, { useContext, useEffect, useRef, useState } from "react";
import ColorItem from "./components/color-item";

import { getShots, getImageData } from "./lib/imageData";
import { TaskContext } from "../../../contexts/task";

import "./color-picker.scss";

function useCanvas(el, image, callback) {
    el.width = image.width;
    el.height = image.height;
    el.getContext("2d").drawImage(image, 0, 0, image.width, image.height);

    return callback();
}

function componentToHex(c) {
    var hex = c.toString(16);

    return hex.length === 1 ? "0" + hex : hex;
}
function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

const ColorPicker = (props) => {
    const { task } = useContext(TaskContext);
    const photoKey = task.context.photographyWipKey;
    const [selectedValue, setSelectedValue] = useState(props.defaultValue);
    const [imageData, setImageData] = useState({ src: "/images/loader.svg", alt: "loader" });
    const imageRef = useRef();
    const canvasRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            const shots = await getShots(photoKey);

            const data = getImageData(photoKey, shots);
            setImageData(data);
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (props.defaultValue !== selectedValue) {
            props.updateOnChange(props.name, selectedValue);
        }
    }, [selectedValue]);

    const removeItem = (index) => {
        const newValue = selectedValue.reduce((arr, color, i) => {
            if (i !== index) {
                arr.push(color);
            }

            return arr;
        }, []);

        setSelectedValue(newValue);
    };

    const onColorSelect = (e) => {
        const nativeEvent = e.nativeEvent;
        let x, y;

        if (nativeEvent.offsetX) {
            x = nativeEvent.offsetX;
            y = nativeEvent.offsetY;
        } else if (nativeEvent.layerX) {
            x = nativeEvent.layerX;
            y = nativeEvent.layerY;
        }

        const canvas = canvasRef.current;
        // TODO: FIX!!!
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useCanvas(canvas, imageRef.current, () => {
            var p = canvas.getContext("2d").getImageData(x, y, 1, 1).data;

            setSelectedValue([...selectedValue, rgbToHex(p[0], p[1], p[2])]);
        });
    };

    const count = selectedValue.length;
    const selectedItems = selectedValue.map((hex, i) => {
        return (
            <ColorItem
                key={`selected_${i}of${count}`}
                removeItem={() => {
                    removeItem(i);
                }}
                hex={hex}
                isActive={true}
            />
        );
    });

    return (
        <div className="color-picker">
            <fieldset>
                <legend>Selected Colors</legend>
                <div className="selected-items">{selectedItems}</div>
            </fieldset>
            <div className="picker-image">
                <img alt={imageData.alt} src={imageData.src} ref={imageRef} onClick={onColorSelect} />
            </div>
            <canvas ref={canvasRef} className="canvas-image"></canvas>
        </div>
    );
};

export default ColorPicker;
